<script setup>
import {defineProps} from 'vue';
import QuestButton from "@/components/list/ContentListButtonQuest";
import PathButton from "@/components/list/ContentListButtonPath";
import ContentButton from "@/components/list/ContentListButtonContent";

const props = defineProps({
    disabled: Boolean,
    content: Object,
    index: Number
});
</script>

<template>
    <QuestButton v-if="props.content.quest_type_key === 'QUEST'" :disabled="props.disabled" :content="content" :index="index" :mobile="true"/>
    <PathButton v-else-if="props.content.quest_type_key === 'PATH'" :content="content" :index="index" :mobile="true"/>
    <ContentButton v-else :content="content" :index="index" :disabled="props.disabled" :mobile="true"/>
</template>
